import React from 'react';
import ReactDOM from 'react-dom';
import GlobalStyle from './GlobalStyle';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initializeGA4 } from './utils/Analytics';
import { TimeTrackingProvider } from './utils/TimeTrackingContext';

initializeGA4();

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
      <TimeTrackingProvider>
        <App />
      </TimeTrackingProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
